import React, {useState} from 'react';
import {NavLink, Outlet, useLocation, useNavigate} from 'react-router-dom';
import {useMemberWallet} from "../../hooks/useMemberWallet";
import {AccountArea} from "../../components/bank/AccountArea";
import {useAccountNavigation} from "../../hooks/useAccountNavigation";
import {BalanceArea} from "../../components/bank/BalanceArea";
import SearchDateSelect from "../../components/common/SearchDateSelect";
import {SearchTypes} from "../../types/common/search.types";
import {setNewSearchType} from "../../utils/search";
import {defaultConfirm} from "../../utils/alert";

export default function Settlement() {
    const navigate = useNavigate();
    const location = useLocation();

    const {memberWalletInfo, loading, error, refetch} = useMemberWallet();

    //------------- 리스트 조회 함수 모음 start ------------------
    const [totalSize, setTotalSize] = useState(0);
    const [searchTrigger, setSearchTrigger] = useState(0);
    const [searchTypes, setSearchTypes] = useState<SearchTypes>(
        setNewSearchType()
    );
    const handleSearch = () => {
        setSearchTypes(prev => ({
            ...prev,
            page: 1
        }));
        setSearchTrigger(prev => prev + 1);
    };
    const handleStartDateChange = (date: string) => {
        setSearchTypes(prev => ({...prev, startDate: date}));
    };
    const handleEndDateChange = (date: string) => {
        setSearchTypes(prev => ({...prev, endDate: date}));
    };
    const handleReset = () => {
        setSearchTypes(
            setNewSearchType()
        );
    };
    //------------- 리스트 조회 함수 모음 end ------------------

    const handleWithdrawalClick = () => {
        if (memberWalletInfo?.accountNo == null) {
            defaultConfirm("출금계좌가 등록되어 있지\n않습니다.\n계좌를 등록 후 출금\n신청을 진행해주세요.", "계좌 등록하기", "닫기",
                (isConfirmed) => {
                    if (isConfirmed) {
                        navigate('/wallet/accountVerification')
                    } else {
                        return;
                    }
                }
            );
        } else {
            navigate('/settlement/withdrawal');
        }
    };


    return (
        <main className="container type_gray">
            <section className="bg-white">
                <div className="inner-top">
                    <h3 className="username"><strong>{memberWalletInfo?.memberName}</strong>님, 반갑습니다.</h3>
                    <BalanceArea
                        className={"main-wallet settlement"}
                        title={"보유 정산 금액"}
                        balance={memberWalletInfo?.depositBalance || 0}
                        expectedBalance={0}
                        expectedBalanceShow={false}
                    />
                    <AccountArea
                        className={"account-bar settlement"}
                        accountNo={memberWalletInfo?.accountNo}
                        bankName={memberWalletInfo?.bankName}
                    />
                </div>
            </section>
            <section className="bg-white no-gap">
                <div className="inner-box">
                    <div className="round-box">
                        <ul className="menu-icon-list">
                            <li>
                                <a onClick={useAccountNavigation(memberWalletInfo?.accountNo)}>
                                    <div className="menu-ico3"></div>
                                    <h4>계좌관리</h4>
                                </a>
                            </li>
                            <li>
                                <a onClick={handleWithdrawalClick}>
                                    <div className="menu-ico2"></div>
                                    <h4>출금신청</h4>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <section className="bg-white">
                <div className="inner-box">
                    <form method="post" id="" className="form-box">
                        <fieldset>
                            <legend>내역 검색 폼</legend>
                            <div className="form-item">
                                <div className="radio-row">
                                    <span className="text-radio black">
                                          <NavLink
                                              to="settlement-list"
                                              replace
                                              className={({isActive}) => (isActive ? "active" : "")}
                                          >
                                            <input
                                                type="radio"
                                                id="radio8"
                                                name="offer"
                                                value=""
                                                checked={location.pathname.includes("settlement-list")}
                                                readOnly
                                            />
                                            <label htmlFor="radio8">정산 내역</label>
                                          </NavLink>
                                    </span>
                                    <span className="text-radio black">
                                        <NavLink
                                            to="withdrawal-list"
                                            replace
                                            className={({isActive}) => (isActive ? "active" : "")}
                                        >
											<input
                                                type="radio"
                                                id="radio9"
                                                name="offer"
                                                value=""
                                                checked={location.pathname.includes("withdrawal-list")}
                                                readOnly
                                            />
											<label htmlFor="radio9">출금 내역</label>
                                        </NavLink>
                                    </span>
                                </div>
                            </div>
                            <SearchDateSelect
                                startDate={searchTypes.startDate}
                                endDate={searchTypes.endDate}
                                onStartDateChange={handleStartDateChange}
                                onEndDateChange={handleEndDateChange}
                                maxMonths={3}
                            />
                            <div className="form-item mt10">
                                <div className="form-btn">
                                    <button
                                        type="button"
                                        className="line-btn"
                                        onClick={handleReset}>초기화
                                    </button>
                                    <button
                                        type="button"
                                        className="submit-btn"
                                        onClick={handleSearch}>검색
                                    </button>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
                <div className="inner-box">
                    <p className="total">총 <span className="point">{totalSize}</span>건의 내역이 조회되었습니다.</p>
                </div>
            </section>

            <Outlet context={{searchTypes, setTotalSize, searchTrigger}}/>

        </main>
    )
};